import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { DetailedSheetPage } from '../../../../../components/pages/backoffice/detailed-sheet-page/detailed-sheet-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/$subscriptionId/detailed-sheet')({
  component: function Component() {
    const { subscriptionId } = Route.useParams()
    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('subscription.read', 'subscription.read.relatedOnly')]}>
        <DetailedSheetPage subscriptionId={subscriptionId} endorsementId={undefined} versionId={undefined} />
      </PermissionChecker>
    )
  },
})
